import React from "react";
import { withTranslation, Trans } from 'react-i18next';
import { updateRoomStatus } from './../models/room';
import Button from './../components/button';
import { Alert } from 'reactstrap';
import moment from "moment";
import Moment from "react-moment";
import { SettingsContext } from "./context";
class ScreenChecked extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isUpdatingStatus: false,
      leaveTevillah: false
    }
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    this.setUpTick();
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  setUpTick() {
    this.tick();
    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
  }

  tick() {
    this.setState({
      time: moment()
    });
  }


  handleChangeStatus(status) {
    let roomId = this.props.room.id;

    this.setState({
      isUpdatingStatus: true,
    })

    updateRoomStatus(roomId, status)
      .then(
        result => {
          this.props.handleUpdateRoom(result);
        },
        error => {
          this.setState({
            isUpdatingStatus: false,
            error
          });
        }
      );
  }


  render() {
    const { t } = this.props;
    const { time, error } = this.state;
    return (
      <div className="body-right attendantInRoom">
        {error!=null
        ? <Alert color="danger">{t("An error occurred.")}</Alert>
        : null}

        <SettingsContext.Consumer>
          {({settings})=> {
            if (settings) {
              let zmanTevilah = settings.zmanTevillah.value;
              const diffInMinutes = moment.duration(moment(zmanTevilah).diff(moment(time).subtract(settings&&settings.offset&&settings.offset.value,'seconds'))).asMinutes();
              const roundedUpMinutes = Math.max(0, Math.ceil(diffInMinutes)); 
              const formattedZman = moment(zmanTevilah).format(t("h:mm")); 
              return moment().isBefore(moment(zmanTevilah))?
                <Alert color="warning"><Trans i18nKey={'zmanTevilahAlert'} count={roundedUpMinutes} values={{ minutes: roundedUpMinutes, zmanTime: formattedZman }}></Trans></Alert>
              :null
            }
          }}
        </SettingsContext.Consumer>
        <div>
          <Button type="circle-big" onClick={() => this.handleChangeStatus("ReadyForMikvah")} loading={this.state.isUpdatingStatus} text={t("Ready For Tevilah")} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ScreenChecked);
